(() => {
  const TOGGLE_SELECTOR = '[data-product-compare-toggle]';
  const DEFAULT_KEY = 'bfaBackpackComparison';
  const ROWS = [
    ['Best for', 'bestFor', 'list'],
    ['Hook & loop patch space', 'hookLoopPatchSpace', 'boolean'],
    ['Dimensions', 'dimensions'],
    ['Dedicated padded laptop compartment', 'laptopCompartment', 'boolean'],
    ['Maximum laptop size', 'maximumLaptopSize'],
    ['Dedicated shoe compartment', 'shoeCompartment', 'boolean'],
    ['Separate wet kit bag included', 'wetKitBagIncluded', 'boolean'],
    ['Bottle holders', 'bottleHolders'],
    ['Water-resistant', 'waterResistant', 'boolean'],
    ['Antimicrobial lining', 'antimicrobialLining', 'boolean'],
    ['Waist & sternum straps', 'waistSternumStraps', 'boolean'],
    ['Ergonomic airflow back panel', 'ergonomicAirflowBackPanel', 'boolean'],
    ['Warranty', 'warranty'],
    ['Cabin-bag friendly', 'cabinBagFriendly', 'cabin'],
    ['Extra features', 'extraFeatures'],
   /* ['Empty weight', 'emptyWeight'],*/
    ['Capacity', 'capacity']
  ];

  const emptyState = () => ({ version: 3, products: [] });
  const parseState = (key) => {
    try {
      const parsed = JSON.parse(localStorage.getItem(key));
      if (!parsed || !Array.isArray(parsed.products)) return emptyState();
      return { version: 3, products: parsed.products };
    } catch (error) {
      return emptyState();
    }
  };
  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;').replaceAll("'", '&#039;');
  const selectedColour = (entry) => entry.colours?.find((c) => c.handle === entry.selectedProductHandle)
    || entry.colours?.find((c) => c.available) || entry.colours?.[0] || null;
  const formatValue = (value, type) => {
    if (type === 'cabin') {
      return value
        ? '<span class="comparison-value comparison-value--yes">✓<sup aria-hidden="true">*</sup></span>'
        : '<span class="comparison-value comparison-value--no">—</span>';
    }
    if (type === 'boolean') return value
      ? '<span class="comparison-value comparison-value--yes">✓</span>'
      : '<span class="comparison-value comparison-value--no">—</span>';
    if (type === 'list') {
      if (!Array.isArray(value) || !value.length) return '<span class="comparison-value--empty">—</span>';
      return `<span>${value.map(escapeHtml).join('<br>')}</span>`;
    }
    if (value === null || value === undefined || value === '') return '<span class="comparison-value--empty">—</span>';
    return escapeHtml(value);
  };

  const hasCabinFriendlyProduct = (products = []) => products.some((entry) => Boolean(entry?.specs?.cabinBagFriendly));

  const cabinDisclaimerMarkup = (products = []) => {
    if (!hasCabinFriendlyProduct(products)) return '';

    return `
      <div class="product-comparison__cabin-note kt-text-size--small"><sup>*</sup>Cabin baggage allowances vary by airline and fare type. Please check your airline’s current size and weight restrictions before travelling.</div>
    `;
  };

  const rowHasDifferences = (products, key) => {
    const normalized = products.map((entry) => JSON.stringify(entry.specs?.[key] ?? null));
    return new Set(normalized).size > 1;
  };

  async function addVariantToCart(button, variantId, quantity = 1) {
    if (!variantId || button.disabled) return;
    const original = button.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = button.dataset.addingLabel || 'Adding…';
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [
          { id: Number(variantId),
            quantity,
            properties: { _source: 'backpack_comparison', "_backpack_comparison":"true" }
          }]
        })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this product.');
      button.textContent = button.dataset.addedLabel || 'Added';
      button.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('bfa:comparison:added-to-cart', { detail: { variantId: Number(variantId), data } }));
      document.dispatchEvent(new CustomEvent('cart-updated', { detail: { source: 'product-comparison' } }));
      document.dispatchEvent(new CustomEvent('krown:cart:update', { detail: { source: 'product-comparison' } }));
      if (typeof window.refreshCart === 'function') await window.refreshCart();
      window.setTimeout(() => {
        button.disabled = false;
        button.classList.remove('is-loading', 'is-added');
        button.textContent = original;
      }, 1600);
    } catch (error) {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = original;
      const host = button.closest('[data-comparison-product-card]') || button.parentElement;
      let message = host?.querySelector('[data-comparison-atc-message]');
      if (!message && host) {
        message = document.createElement('p');
        message.dataset.comparisonAtcMessage = '';
        message.className = 'product-comparison-product__message';
        message.setAttribute('role', 'alert');
        host.append(message);
      }
      if (message) message.textContent = error.message;
    }
  }

  const renderColourButtons = (entry, colour) => (entry.colours || []).map((item) => {
    const selected = item.handle === colour?.handle;
    return `<button type="button" class="product-comparison-colour${selected ? ' is-selected' : ''}" data-comparison-colour data-group-handle="${escapeHtml(entry.groupHandle)}" data-product-handle="${escapeHtml(item.handle)}" aria-label="${escapeHtml(item.title)}${item.available ? '' : ', sold out'}" aria-pressed="${selected}" ${item.available ? '' : 'disabled'}>${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy" width="42" height="42">` : ''}</button>`;
  }).join('');

  const renderProductHeader = (entry, options = {}) => {
    const colour = selectedColour(entry);
    const sale = Number(colour?.compareAtPrice) > Number(colour?.price);
    const addLabel = options.addLabel || 'Add to cart';
    const soldOutLabel = options.soldOutLabel || 'Sold out';
    const viewLabel = options.viewLabel || 'View details';
    return `<div class="product-comparison-product" data-comparison-product-card>
      <button type="button" class="product-comparison-product__remove" data-comparison-remove="${escapeHtml(entry.groupHandle)}" aria-label="Remove ${escapeHtml(entry.groupTitle)}"><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m3 3 10 10M13 3 3 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>
      <a href="${escapeHtml(colour?.url || '#')}" class="product-comparison-product__image-link">${colour?.image ? `<img class="product-comparison-product__image" src="${escapeHtml(colour.image)}" alt="${escapeHtml(colour.title)}" loading="lazy" width="360" height="360">` : '<span class="product-comparison-product__image product-comparison-product__image--placeholder"></span>'}</a>
      <h3 class="product-comparison-product__title"><a href="${escapeHtml(colour?.url || '#')}">${escapeHtml(entry.shortLabel || entry.groupTitle)}</a></h3>
      <p class="product-comparison-product__colour-name">${escapeHtml(colour?.title || '')}</p>
      <p class="product-comparison-product__price"><span>${escapeHtml(colour?.priceFormatted || '')}</span>${sale ? `<s>${escapeHtml(colour.compareAtPriceFormatted || '')}</s>` : ''}</p>
      <div class="product-comparison-product__colours" aria-label="Choose colour">${renderColourButtons(entry, colour)}</div>
      <div class="product-comparison-product__actions">
        <button type="button" class="kt-button kt-button--small kt-button--solid kt-button--hover-opacity product-comparison-product__button" data-comparison-add-to-cart data-variant-id="${escapeHtml(colour?.variantId || '')}" data-adding-label="Adding…" data-added-label="Added" ${colour?.available ? '' : 'disabled'}>${colour?.available ? escapeHtml(addLabel) : escapeHtml(soldOutLabel)}</button>
        <a class="kt-button kt-button--small kt-button--outline kt-button--hover-opacity product-comparison-product__details" href="${escapeHtml(colour?.url || '#')}">${escapeHtml(viewLabel)}</a>
      </div>
      <p class="product-comparison-product__message" data-comparison-atc-message aria-live="polite"></p>
    </div>`;
  };

  class ProductComparisonTray extends HTMLElement {
    constructor() {
      super();
      this.storageKey = this.dataset.storageKey || DEFAULT_KEY;
      this.collapseStorageKey = `${this.storageKey}:trayCollapsed`;
      this.limit = Number(this.dataset.limit || 4);
      this.comparisonUrl = this.dataset.comparisonUrl || '';
      this.state = parseState(this.storageKey);
      this.productsContainer = this.querySelector('[data-comparison-products]');
      this.countElement = this.querySelector('[data-comparison-count]');
      this.openButton = this.querySelector('[data-comparison-open]');
      this.trayToggleButton = this.querySelector('[data-comparison-tray-toggle]');
      this.modal = this.querySelector('[data-comparison-modal]');
      this.modalPanel = this.querySelector('[data-comparison-modal-panel]');
      this.modalContent = this.querySelector('[data-comparison-modal-content]');
      this.lastFocusedElement = null;
    }
    connectedCallback() {
      this.onChange = this.handleDocumentChange.bind(this);
      this.onClick = this.handleDocumentClick.bind(this);
      this.onRefresh = this.handleExternalRefresh.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      document.addEventListener('change', this.onChange);
      document.addEventListener('click', this.onClick);
      document.addEventListener('krown:main-collection-grid:filtered', this.onRefresh);
      document.addEventListener('shopify:section:load', this.onRefresh);
      window.addEventListener('storage', this.onRefresh);
      document.addEventListener('keydown', this.onKeydown);
      this.restoreTrayCollapse();
      this.hydrateLegacyEntries(); this.render();
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onChange); document.removeEventListener('click', this.onClick);
      document.removeEventListener('krown:main-collection-grid:filtered', this.onRefresh); document.removeEventListener('shopify:section:load', this.onRefresh);
      window.removeEventListener('storage', this.onRefresh); document.removeEventListener('keydown', this.onKeydown);
    }
    handleKeydown(event) {
      if (!this.isModalOpen()) return;
      if (event.key === 'Escape') { event.preventDefault(); this.closeModal(); return; }
      if (event.key !== 'Tab' || !this.modalPanel) return;
      const focusable = [...this.modalPanel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null);
      if (!focusable.length) { event.preventDefault(); this.modalPanel.focus(); return; }
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    handleExternalRefresh(event) {
      if (event.type === 'storage') {
        if (event.key === this.collapseStorageKey) {
          this.restoreTrayCollapse();
          return;
        }
        if (event.key && event.key !== this.storageKey) return;
      }
      this.state = parseState(this.storageKey);
      this.hydrateLegacyEntries();
      this.render();
      if (this.isModalOpen()) this.renderModal();
    }
    handleDocumentChange(event) {
      const input = event.target.closest(TOGGLE_SELECTOR); if (!input) return;
      const entry = this.entryFromInput(input); if (!entry) { input.checked = false; this.setMessage('Comparison data is unavailable for this product.'); return; }
      const existingIndex = this.state.products.findIndex((item) => item.groupHandle === entry.groupHandle);
      if (input.checked) {
        if (existingIndex !== -1) { this.state.products.splice(existingIndex, 1, entry);  }
        else if (this.state.products.length >= this.limit) { input.checked = false; this.setMessage(`You can compare up to ${this.limit} backpacks.`); return; }
        else { this.state.products.push(entry); }
      } else if (existingIndex !== -1) { this.state.products.splice(existingIndex, 1); }
      this.save(); this.render();
    }
    handleDocumentClick(event) {
      const remove = event.target.closest('[data-comparison-remove]'); if (remove) { this.remove(remove.dataset.comparisonRemove); return; }
      const colour = event.target.closest('[data-comparison-colour]'); if (colour) { this.selectColour(colour.dataset.groupHandle, colour.dataset.productHandle); return; }
      const atc = event.target.closest('[data-comparison-add-to-cart]'); if (atc) { addVariantToCart(atc, atc.dataset.variantId); return; }
      if (event.target.closest('[data-comparison-clear]')) { this.state.products=[]; this.save();  this.closeModal(); this.render(); return; }
      if (event.target.closest('[data-comparison-tray-toggle]')) { this.toggleTrayCollapse(); return; }
      if (event.target.closest('[data-comparison-open]')) { this.openModal(); return; }
      if (event.target.closest('[data-comparison-modal-close], [data-comparison-modal-backdrop]')) { this.closeModal(); return; }
      if (event.target.closest('[data-comparison-full-page]')) this.openFullComparison();
    }
    entryFromInput(input) {
      const script=input.closest('.product-compare-toggle')?.querySelector('[data-product-compare-data]'); if (!script) return null;
      try { const entry=JSON.parse(script.textContent); const selected=selectedColour(entry); entry.selectedProductHandle=selected?.handle||''; entry.addedAt=Date.now(); return entry; }
      catch(error){ console.error('Unable to parse product comparison data.',error); return null; }
    }
    hydrateLegacyEntries() {
      let changed=false; this.state.products=this.state.products.map((entry)=>{
        if(entry.colours&&entry.specs)return entry;
        const input=[...document.querySelectorAll(TOGGLE_SELECTOR)].find((el)=>el.dataset.groupHandle===entry.groupHandle);
        const hydrated=input?this.entryFromInput(input):null; if(hydrated){hydrated.selectedProductHandle=entry.selectedProductHandle||hydrated.selectedProductHandle;changed=true;return hydrated;} return entry;
      }); if(changed)this.save();
    }
    selectColour(groupHandle, productHandle) { const entry=this.state.products.find((p)=>p.groupHandle===groupHandle); const colour=entry?.colours?.find((c)=>c.handle===productHandle); if(!entry||!colour||!colour.available)return; entry.selectedProductHandle=productHandle; this.save();  this.render(); this.renderModal(); }
    remove(groupHandle) { this.state.products=this.state.products.filter((p)=>p.groupHandle!==groupHandle); this.save(); if(this.state.products.length<2)this.closeModal(); this.render(); this.renderModal(); }
    save(){localStorage.setItem(this.storageKey,JSON.stringify(this.state));window.dispatchEvent(new CustomEvent('bfa:comparison:updated',{detail:{products:this.state.products}}));}
    setMessage(message){if(this.messageElement)this.messageElement.textContent=message;}
    syncInputs(){const groups=new Set(this.state.products.map((p)=>p.groupHandle));document.querySelectorAll(TOGGLE_SELECTOR).forEach((input)=>{const selected=groups.has(input.dataset.groupHandle);input.checked=selected;const status=input.closest('.product-compare-toggle')?.querySelector('[data-product-compare-status]');if(status)status.textContent=selected?'Selected for comparison':'Not selected for comparison';});}
    render(){
      const products=this.state.products.slice(0,this.limit);
      this.state.products=products;
      this.hidden=products.length===0;
      if(this.countElement)this.countElement.textContent=`${products.length} of ${this.limit} selected`;
      if(this.productsContainer){
        const slots=Array.from({length:this.limit},(_,index)=>products[index]||null);
        this.productsContainer.innerHTML=slots.map((entry,index)=>entry?this.renderTrayItem(entry):this.renderEmptyTrayItem(index)).join('');
      }
      if(this.openButton){
        this.openButton.disabled=products.length<2;
        this.openButton.setAttribute('aria-label',`Compare ${products.length} backpacks`);
      }
      this.updateTrayToggle();
      this.syncInputs();
    }
    renderTrayItem(entry){const colour=selectedColour(entry);const sale=Number(colour?.compareAtPrice)>Number(colour?.price);return `<article class="product-comparison-item">${colour?.image?`<img class="product-comparison-item__image" src="${escapeHtml(colour.image)}" alt="" loading="lazy" width="52" height="52">`:'<span class="product-comparison-item__image product-comparison-item__image--placeholder"></span>'}<div class="product-comparison-item__content"><span class="product-comparison-item__group">${escapeHtml(entry.shortLabel||entry.groupTitle)}</span><span class="product-comparison-item__price"><span>${escapeHtml(colour?.priceFormatted||'')}</span>${sale?`<s>${escapeHtml(colour?.compareAtPriceFormatted||'')}</s>`:''}</span></div><button type="button" class="product-comparison-item__remove" data-comparison-remove="${escapeHtml(entry.groupHandle)}" aria-label="Remove ${escapeHtml(entry.groupTitle)}"><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m3 3 10 10M13 3 3 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button></article>`;}
    renderEmptyTrayItem(index){return `<div class="product-comparison-item product-comparison-item--empty" aria-label="Empty comparison position ${index+1}"><span class="product-comparison-item__number">${index+1}</span></div>`;}
    isTrayCollapsed(){return this.classList.contains('is-collapsed');}
    restoreTrayCollapse(){
      let collapsed=false;
      try { collapsed=localStorage.getItem(this.collapseStorageKey)==='true'; }
      catch(error) { collapsed=false; }
      this.classList.toggle('is-collapsed',collapsed);
      this.updateTrayToggle();
    }
    saveTrayCollapse(){
      try { localStorage.setItem(this.collapseStorageKey,String(this.isTrayCollapsed())); }
      catch(error) { /* Storage can be unavailable in restricted browsing modes. */ }
    }
    toggleTrayCollapse(){
      this.classList.toggle('is-collapsed');
      this.saveTrayCollapse();
      this.updateTrayToggle();
    }
    updateTrayToggle(){
      if(!this.trayToggleButton)return;
      const collapsed=this.isTrayCollapsed();
      this.trayToggleButton.setAttribute('aria-expanded',String(!collapsed));
      this.trayToggleButton.setAttribute('aria-label',collapsed?'Expand comparison tray':'Collapse comparison tray');
    }
    isModalOpen(){return Boolean(this.modal&&!this.modal.hidden&&this.modal.getAttribute('aria-hidden')==='false');}
    openModal(){if(!this.modal||this.state.products.length<2||this.isModalOpen())return;this.renderModal();this.lastFocusedElement=document.activeElement;this.modal.hidden=false;this.modal.setAttribute('aria-hidden','false');document.documentElement.classList.add('comparison-modal-open');requestAnimationFrame(()=>{this.modal.classList.add('is-open');(this.modalPanel?.querySelector('[data-comparison-modal-close],a[href],button:not([disabled])')||this.modalPanel)?.focus();});}
    closeModal(){if(!this.modal||!this.isModalOpen())return;this.modal.classList.remove('is-open');this.modal.setAttribute('aria-hidden','true');document.documentElement.classList.remove('comparison-modal-open');setTimeout(()=>{if(this.modal?.getAttribute('aria-hidden')==='true')this.modal.hidden=true;},180);if(this.lastFocusedElement instanceof HTMLElement&&document.contains(this.lastFocusedElement))this.lastFocusedElement.focus();this.lastFocusedElement=null;}
    renderModal(){
      if(!this.modalContent||!this.state.products.length)return;
      const products=this.state.products;
      const columns=products.length;
      const productRow=`<div class="product-comparison-grid__row product-comparison-grid__row--products" style="--comparison-columns:${columns}"><div class="product-comparison-grid__label product-comparison-grid__label--top">Backpack</div>${products.map((entry)=>renderProductHeader(entry,{addLabel:this.dataset.addLabel,soldOutLabel:this.dataset.soldOutLabel,viewLabel:this.dataset.viewLabel})).join('')}</div>`;
      const specRows=ROWS.map(([label,key,type])=>`<div class="product-comparison-grid__row" style="--comparison-columns:${columns}"><div class="product-comparison-grid__label">${escapeHtml(label)}</div>${products.map((entry)=>`<div class="product-comparison-grid__value">${formatValue(entry.specs?.[key],type)}</div>`).join('')}</div>`).join('');
      this.modalContent.innerHTML=`<div class="product-comparison-grid">${productRow}${specRows}</div>${cabinDisclaimerMarkup(products)}`;
    }
    openFullComparison(){if(!this.comparisonUrl||this.state.products.length<2)return;const url=new URL(this.comparisonUrl,window.location.origin);url.searchParams.set('products',this.state.products.map((p)=>p.selectedProductHandle).join(','));window.location.assign(url.toString());}
  }

  class ProductComparisonPage extends HTMLElement {
    constructor(){
      super();
      this.storageKey=this.dataset.storageKey||DEFAULT_KEY;
      this.state=parseState(this.storageKey);
      this.state.products=this.state.products.slice(0,4);
      this.content=this.querySelector('[data-full-comparison-content]');
      this.count=this.querySelector('[data-full-comparison-count]');
      this.differencesOnly=false;
      this.catalog=this.readCatalog();
    }
    connectedCallback(){
      this.onClick=this.handleClick.bind(this);
      this.onChange=this.handleChange.bind(this);
      this.onRefresh=this.handleRefresh.bind(this);
      this.addEventListener('click',this.onClick);
      this.addEventListener('change',this.onChange);
      window.addEventListener('storage',this.onRefresh);
      window.addEventListener('bfa:comparison:updated',this.onRefresh);
      this.mergeStoredEntriesWithCatalog();
      this.render();
    }
    disconnectedCallback(){
      this.removeEventListener('click',this.onClick);
      this.removeEventListener('change',this.onChange);
      window.removeEventListener('storage',this.onRefresh);
      window.removeEventListener('bfa:comparison:updated',this.onRefresh);
    }
    readCatalog(){
      const byGroup=new Map();
      this.querySelectorAll('[data-comparison-catalog-item]').forEach((script)=>{
        try {
          const entry=JSON.parse(script.textContent);
          if(!entry?.groupHandle)return;
          const existing=byGroup.get(entry.groupHandle);
          if(!existing){
            byGroup.set(entry.groupHandle,entry);
            return;
          }
          const colours=[...(existing.colours||[])];
          (entry.colours||[]).forEach((colour)=>{
            if(!colours.some((item)=>item.handle===colour.handle))colours.push(colour);
          });
          existing.colours=colours;
        } catch(error){
          console.error('Unable to parse comparison catalog item.',error);
        }
      });
      return [...byGroup.values()].sort((a,b)=>String(a.shortLabel||a.groupTitle).localeCompare(String(b.shortLabel||b.groupTitle)));
    }
    cloneEntry(entry){
      return JSON.parse(JSON.stringify(entry));
    }
    mergeStoredEntriesWithCatalog(){
      let changed=false;
      this.state.products=this.state.products.slice(0,4).map((stored)=>{
        const fresh=this.catalog.find((item)=>item.groupHandle===stored.groupHandle);
        if(!fresh)return stored;
        const merged=this.cloneEntry(fresh);
        const storedColour=(merged.colours||[]).find((colour)=>colour.handle===stored.selectedProductHandle);
        merged.selectedProductHandle=(storedColour?.available?storedColour:null)?.handle || selectedColour(merged)?.handle || '';
        changed=true;
        return merged;
      });
      if(changed)this.save(false);
    }
    handleRefresh(){
      this.state=parseState(this.storageKey);
      this.state.products=this.state.products.slice(0,4);
      this.mergeStoredEntriesWithCatalog();
      this.render();
    }
    handleChange(event){
      if(event.target.matches('[data-comparison-differences-only]')){
        this.differencesOnly=event.target.checked;
        this.render();
        return;
      }
      const selector=event.target.closest('[data-comparison-slot-select]');
      if(selector){
        const index=Number(selector.dataset.slotIndex);
        const groupHandle=selector.value;
        if(!groupHandle){
          if(index<this.state.products.length)this.state.products.splice(index,1);
          this.save();
          this.render();
          return;
        }
        const candidate=this.catalog.find((entry)=>entry.groupHandle===groupHandle);
        if(!candidate)return;
        const duplicateIndex=this.state.products.findIndex((entry,entryIndex)=>entry.groupHandle===groupHandle&&entryIndex!==index);
        if(duplicateIndex!==-1)return;
        const next=this.cloneEntry(candidate);
        next.selectedProductHandle=selectedColour(next)?.handle||'';
        if(index<this.state.products.length)this.state.products[index]=next;
        else if(this.state.products.length<4)this.state.products.push(next);
        this.save();
        this.render();
      }
    }
    handleClick(event){
      const remove=event.target.closest('[data-comparison-remove]');
      if(remove){
        const index=this.state.products.findIndex((entry)=>entry.groupHandle===remove.dataset.comparisonRemove);
        if(index!==-1)this.state.products.splice(index,1);
        this.save();
        this.render();
        return;
      }
      const colour=event.target.closest('[data-comparison-colour]');
      if(colour){
        const entry=this.state.products.find((p)=>p.groupHandle===colour.dataset.groupHandle);
        const selected=entry?.colours?.find((c)=>c.handle===colour.dataset.productHandle);
        if(entry&&selected?.available){
          entry.selectedProductHandle=selected.handle;
          this.save();
          this.render();
        }
        return;
      }
      const atc=event.target.closest('[data-comparison-add-to-cart]');
      if(atc){addVariantToCart(atc,atc.dataset.variantId);return;}
      if(event.target.closest('[data-comparison-clear]')){
        this.state=emptyState();
        this.save();
        this.render();
      }
    }
    save(dispatch=true){
      localStorage.setItem(this.storageKey,JSON.stringify(this.state));
      if(dispatch)window.dispatchEvent(new CustomEvent('bfa:comparison:updated',{detail:{products:this.state.products}}));
    }
    renderSelect(entry,index){
      const selectedGroups=new Set(this.state.products.map((item)=>item.groupHandle));
      const label=this.dataset.selectLabel||'Choose a backpack';
      const options=this.catalog.map((item)=>{
        const isSelected=entry?.groupHandle===item.groupHandle;
        const disabled=!isSelected&&selectedGroups.has(item.groupHandle);
        return `<option value="${escapeHtml(item.groupHandle)}" ${isSelected?'selected':''} ${disabled?'disabled':''}>${escapeHtml(item.shortLabel||item.groupTitle)}</option>`;
      }).join('');
      return `<label class="product-comparison-slot__selector"><span class="kt-visually-hidden">Backpack for comparison column ${index+1}</span><select data-comparison-slot-select data-slot-index="${index}"><option value="">${escapeHtml(label)}</option>${options}</select></label>`;
    }
    renderSlot(entry,index){
      const card=entry
        ? renderProductHeader(entry,{addLabel:this.dataset.addLabel,soldOutLabel:this.dataset.soldOutLabel,viewLabel:this.dataset.viewLabel})
        : `<div class="product-comparison-slot__empty"><span>${escapeHtml(this.dataset.emptySlotLabel||'Choose a backpack above to compare it.')}</span></div>`;
      return `<div class="product-comparison-slot">${this.renderSelect(entry,index)}${card}</div>`;
    }
    render(){
      const products=this.state.products.slice(0,4);
      this.state.products=products;
      if(this.count)this.count.textContent=`${products.length} of 4 backpacks selected`;
      if(!this.content)return;
      const rows=this.differencesOnly?ROWS.filter(([,key])=>rowHasDifferences(products,key)):ROWS;
      const slots=Array.from({length:4},(_,index)=>products[index]||null);
      const productRow=`<div class="product-comparison-grid__row product-comparison-grid__row--products" style="--comparison-columns:4"><div class="product-comparison-grid__label product-comparison-grid__label--top">Backpack</div>${slots.map((entry,index)=>this.renderSlot(entry,index)).join('')}</div>`;
      const specRows=rows.map(([label,key,type])=>`<div class="product-comparison-grid__row" style="--comparison-columns:4"><div class="product-comparison-grid__label">${escapeHtml(label)}</div>${slots.map((entry)=>`<div class="product-comparison-grid__value">${entry?formatValue(entry.specs?.[key],type):'<span class="comparison-value--empty">—</span>'}</div>`).join('')}</div>`).join('');
      this.content.innerHTML=`<div class="product-comparison-page__scroller"><div class="product-comparison-grid product-comparison-grid--page">${productRow}${specRows}</div></div>${cabinDisclaimerMarkup(products)}${this.differencesOnly&&products.length>1&&!rows.length?'<p class="product-comparison-page__no-differences">The selected backpacks have no differing populated values.</p>':''}`;
    }
  }

  if(!customElements.get('product-comparison-tray'))customElements.define('product-comparison-tray',ProductComparisonTray);
  if(!customElements.get('product-comparison-page'))customElements.define('product-comparison-page',ProductComparisonPage);
})();
